
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDefinitions } from "../../InventoryStates/Display.js";
import { join, printf, toText } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { empty, singleton as singleton_1, toArray, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { InfiniteTable } from "../../Widgets/Table/InfiniteTable.js";
import { singleton, append, delay, toArray as toArray_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { LabelId } from "../../Shared/Shared.js";
import { Label } from "../../Shared/Category.js";
import { OnTableRowClick$1, ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { inventoryTableConfiguration } from "../Common.js";
import { RouterModule_encodeParts } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";

export function ReportView(props) {
    let elems_5, elems_4, elems, elems_1, elems_2, elems_3, TableRows;
    const t = useTranslation()[0];
    const definitions = useDefinitions();
    const formatPercent = (count, total) => {
        if (total > 0) {
            const percent = (count / total) * 100;
            return toText(printf("%d (%.1f %%)"))(count)(percent);
        }
        else {
            return toText(printf("%d (0.0 %%)"))(count);
        }
    };
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems_5 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-4", "mb-4", "p-4"])], (elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "bg-[#EFFEF4]", "rounded-lg", "p-4", "text-center"])], (elems = [reactElement("div", {
        className: join(" ", ["text-sm", "text-[#1E6939]", "mb-1"]),
        children: t("report.uninspected_tools_stat_inspected"),
    }), reactElement("div", {
        className: join(" ", ["text-2xl", "font-bold", "text-[#1E6939]"]),
        children: formatPercent(props.Report.InspectedCount, props.Report.TotalInspectionRequiredCount),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "bg-[#FEFCE8]", "rounded-lg", "p-4", "text-center"])], (elems_1 = [reactElement("div", {
        className: join(" ", ["text-sm", "text-[#854E0E]", "mb-1"]),
        children: t("report.uninspected_tools_stat_expired"),
    }), reactElement("div", {
        className: join(" ", ["text-2xl", "font-bold", "text-[#854E0E]"]),
        children: formatPercent(props.Report.ExpiredCount, props.Report.TotalInspectionRequiredCount),
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "bg-light-red", "rounded-lg", "p-4", "text-center"])], (elems_2 = [reactElement("div", {
        className: join(" ", ["text-sm", "text-[#981B1B]", "mb-1"]),
        children: t("report.uninspected_tools_stat_never_inspected"),
    }), reactElement("div", {
        className: join(" ", ["text-2xl", "font-bold", "text-[#981B1B]"]),
        children: formatPercent(props.Report.NeverInspectedCount, props.Report.TotalInspectionRequiredCount),
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "bg-light-red", "rounded-lg", "p-4", "text-center"])], (elems_3 = [reactElement("div", {
        className: join(" ", ["text-sm", "text-[#981B1B]", "mb-1"]),
        children: t("report.uninspected_tools_stat_failed"),
    }), reactElement("div", {
        className: join(" ", ["text-2xl", "font-bold", "text-[#981B1B]"]),
        children: formatPercent(props.Report.FailedCount, props.Report.TotalInspectionRequiredCount),
    })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement(InfiniteTable, (TableRows = toArray(props.Report.Rows), {
        ColumnDefinitions: toArray_1(delay(() => append(singleton(new ColumnDefinition$1("status", "", t("report.uninspected_tools_status"), (row) => {
            let matchValue, matchValue_1;
            return new CellContent(4, [singleton_1(new Label(new LabelId("00000000-0000-0000-0000-000000000000"), (matchValue = row.Status, (matchValue.tag === 1) ? t("report.uninspected_tools_expired") : ((matchValue.tag === 2) ? t("report.uninspected_tools_failed") : t("report.uninspected_tools_never_inspected"))), (matchValue_1 = row.Status, (matchValue_1.tag === 1) ? "#fd7e14" : ((matchValue_1.tag === 2) ? "#dc3545" : "#dc3545")), true, undefined))]);
        }, "select", "text")), delay(() => append(singleton(new ColumnDefinition$1("inspectionTemplates", "", t("report.uninspected_tools_templates"), (row_1) => (new CellContent(0, [join(", ", row_1.InspectionTemplateNames)])), "text", "text")), delay(() => map((columnDefinition) => (new ColumnDefinition$1(columnDefinition.Id, columnDefinition.Group, columnDefinition.Header, (row_2) => columnDefinition.AccessorFunction(row_2.Inventory), columnDefinition.Filter, columnDefinition.ColumnType)), inventoryTableConfiguration(t, definitions, props.PropertyConfigurations, props.Customer, props.Configuration)))))))),
        Controls: empty(),
        Options: {
            BorderStyle: "full",
            CSVDownload: true,
            ConfigurableColumns: true,
            CustomTableFilters: false,
            DefaultSortColumn: ["status", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            OnRowClick: new OnTableRowClick$1(1, [(row_3) => RouterModule_encodeParts(ofArray(["tools", row_3.Inventory.Id]), 1)]),
            RowSelection: "disabled",
            SaveTableConfiguration: false,
            WithQueryParameters: false,
        },
        TableKey: "uninspected-tools-report",
        TableRows: TableRows,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

